'use strict';

export const MISSING_PROJECT_CODE_SUFFIX = 'Missing Project Code in filename';

export const getFilesMissingProjectCode = (files = [], projectCode = '') => {
	const normalizedProjectCode = (projectCode || '').toLowerCase();

	if (!normalizedProjectCode) {
		return [];
	}

	return files
		.map((file) => file?.name || '[Missing filename]')
		.filter((fileName) => !fileName.toLowerCase().includes(normalizedProjectCode));
};

export const getMissingProjectCodeMessages = (files = [], projectCode = '') => (
	getFilesMissingProjectCode(files, projectCode)
		.map((fileName) => `${fileName} - ${MISSING_PROJECT_CODE_SUFFIX}`)
);
